module.exports = __webpack_public_path__ + "img/Rectangle 10118@2x.618e2b4a.png";